var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { BreakpointsConsumer } from './BreakpointsProvider';
var On = /** @class */ (function (_super) {
    __extends(On, _super);
    function On() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkPropFormat = function (breakpointsAndDims) {
            var renderIf = _this.props.renderIf;
            if (typeof renderIf === 'boolean') {
                return renderIf;
            }
            else if (typeof renderIf === 'function') {
                return renderIf(breakpointsAndDims);
            }
            // todo: log props not formatted correctly (or bug)
            return true;
        };
        return _this;
    }
    On.prototype.render = function () {
        var _this = this;
        return (_jsx(BreakpointsConsumer, { children: function (breakpointsAndDims) {
                if (_this.checkPropFormat(breakpointsAndDims)) {
                    return _this.props.children;
                }
                return null;
            } }, void 0));
    };
    On.defaultProps = {
        renderIf: true
    };
    return On;
}(React.Component));
export default On;
